import(/* webpackMode: "eager" */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/app/catalog/[category]/page.tsx");
